import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { requiresAuthGuard } from './guards/requires-auth.guard';
import { AuthenticatedLayoutComponent } from './layouts/authenticated-layout/authenticated-layout.component';

export const routes: Routes = [
  // Auth routes — public (no guard)
  {
    path: 'auth',
    loadComponent: () =>
      import('./pages/auth/auth.component').then(m => m.AuthComponent),
  },
  {
    path: 'auth/verify-email',
    loadComponent: () =>
      import('./pages/auth/email-verification/email-verification.component').then(
        m => m.EmailVerificationComponent
      ),
  },

  // Onboarding — requires authentication but not a role (new users land here)
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./pages/onboarding/onboarding.component').then(m => m.OnboardingComponent),
  },

  // No canActivate — Stripe redirects here after checkout, before auth state fully settles.
  // Both pages are stateless / show no sensitive data if accessed unauthenticated.
  {
    path: 'settings/billing/success',
    loadComponent: () =>
      import('./pages/billing/checkout-success/checkout-success.component').then(
        m => m.CheckoutSuccessComponent
      ),
  },
  {
    path: 'settings/billing/cancel',
    loadComponent: () =>
      import('./pages/billing/checkout-cancel/checkout-cancel.component').then(
        m => m.CheckoutCancelComponent
      ),
  },

  // Subscribe page — standalone, no sidebar. Target of authGuard redirect when access has lapsed.
  // Uses requiresAuthGuard so lapsed/expired-trial users can reach it without triggering the
  // hasActiveAccess() check that would create an infinite redirect loop.
  {
    path: 'billing',
    canActivate: [requiresAuthGuard],
    loadComponent: () =>
      import('./pages/billing/billing.component').then(m => m.BillingComponent),
  },

  // Pre-auth invite acceptance — standalone, no sidebar
  {
    path: 'join/coach/:inviteCode',
    canActivate: [requiresAuthGuard],
    loadComponent: () =>
      import('./pages/join/join.component').then(m => m.JoinComponent),
  },

  // Authenticated layout shell — sidebar present on all child routes
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./pages/settings/settings.routes').then(m => m.settingsRoutes),
      },
      {
        path: 'roster',
        loadComponent: () =>
          import('./pages/roster/roster.component').then(m => m.RosterComponent),
      },
      {
        path: 'roster/invite',
        loadComponent: () =>
          import('./pages/roster/invite/invite.component').then(m => m.InviteComponent),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: '**', redirectTo: '/auth' },
    ],
  },
];
